export default __webpack_public_path__ + "static/media/alert-illustration-shared.fb254c70.webp";